
const devUrl = 'http://localhost:3000';
const prodUrl = 'https://nurate.me';

export const baseUrl = process.env.NODE_ENV === 'development' ? devUrl : prodUrl;
console.log(baseUrl);
console.log(process.env.NODE_ENV);

export default {
  LANDING: '/',
  SIGN_IN: '/signin',
  SIGN_IN_VERIFICATION: '/signin-verification',

}